<template>
  <div id="app">

    <div class="overlay" data-toggle="sidemenu" aria-controls="sidemenu" v-show="overlay" @click="closeMenu"></div>

    <div class="loading-overlay" v-show="syncOverlay">
      <div class="counter text-center">
        <h3>Synkroniserer data<span class="loading-overview"><span>.</span><span>.</span><span>.</span></span></h3>
        <p>Trin {{activeStep}} ud af {{totalSteps}}</p>
        <p class="error-message" v-if="errorMessage.length > 0">{{errorMessage}}</p>
      </div>
    </div>

    <header id="header">
      <div class="left" data-toggle="sidemenu" aria-controls="sidemenu" @click="showMenu">
        <i class="material-icons">menu</i>
        <p class="small-icon notification" v-if="notification > 0">!</p>
      </div>
      <h1>Opgaver</h1>
      <div class="right" @click="gotoMap">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 533.333 533.333" style="enable-background:new 0 0 533.333 533.333;" xml:space="preserve">
          <g>
            <path d="M455.229,78.105c50.367,50.367,78.104,117.333,78.104,188.563c0,71.229-27.739,138.194-78.104,188.561   c-50.368,50.366-117.333,78.104-188.562,78.104c-71.229,0-138.195-27.738-188.562-78.104C27.738,404.862,0,337.896,0,266.668   c0-71.229,27.736-138.196,78.104-188.563S195.438,0,266.667,0C337.896,0,404.861,27.738,455.229,78.105z M431.658,431.659   c32.843-32.843,54.681-73.754,63.686-118.262c-7.019,10.331-13.732,14.165-17.888-8.961c-4.281-37.703-38.911-13.618-60.688-27.011   c-22.919,15.447-74.43-30.032-65.676,21.263c13.507,23.137,72.921-30.964,43.307,17.99   c-18.893,34.176-69.085,109.86-62.555,149.093c0.823,57.158-58.404,11.919-78.81-7.041   c-13.727-37.979-4.678-104.362-40.572-122.962c-38.959-1.691-72.398-5.232-87.497-48.786c-9.086-31.161,9.669-77.549,43.062-84.71   c48.88-30.711,66.341,35.965,112.183,37.205c14.233-14.893,53.029-19.628,56.246-36.328c-30.078-5.308,38.16-25.291-2.879-36.657   c-22.642,2.663-37.229,23.476-25.193,41.124c-43.874,10.23-45.279-63.492-87.454-40.238c-1.072,36.765-68.865,11.919-23.456,4.464   c15.602-6.816-25.448-26.57-3.271-22.98c10.894-0.592,47.569-13.444,37.644-22.084c20.421-12.677,37.583,30.359,57.572-0.98   c14.431-24.097-6.052-28.546-24.141-16.332c-10.198-11.418,18.006-36.081,42.882-46.738c8.29-3.552,16.208-5.487,22.263-4.939   c12.531,14.475,35.703,16.982,36.916-1.741c-31.031-14.861-65.247-22.712-100.672-22.712c-50.845,0-99.203,16.158-139.223,46.036   c10.755,4.927,16.86,11.062,6.499,18.904c-8.05,23.987-40.713,56.186-69.387,51.627c-14.889,25.674-24.694,53.961-28.885,83.608   c24.016,7.946,29.554,23.672,24.394,28.932c-12.237,10.671-19.759,25.797-23.633,42.355c7.817,47.832,30.298,91.914,65.245,126.862   C145.746,475.729,204.34,500,266.667,500C328.992,500,387.587,475.729,431.658,431.659z" 
              fill="#FFFFFF"/>
          </g>
        </svg>
      </div>
    </header>

    <div id="sidemenu" class="sidemenu fast" data-toggler data-animate="slide-in-left slide-out-left" style="display: none;">
      <div class="close-button" data-toggle="sidemenu" aria-controls="sidemenu" @click="closeMenu">
        <span aria-hidden="true">×</span>
      </div>
      <div class="header-menu">
        <h2><b>Måler</b>tjek</h2>
      </div>
      <ul>
        <li id="projekter" class="active">
          <a data-toggle="sidemenu" aria-controls="sidemenu" @click="gotoProjects">
            <div class="icon">
              <i class="material-icons">assignment</i>
            </div>
            Opgaver
          </a>
        </li>
        <li id="kort">
          <a data-toggle="sidemenu" aria-controls="sidemenu" class="map-item" @click="gotoMap">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 533.333 533.333" style="enable-background:new 0 0 533.333 533.333;" xml:space="preserve">
                <g>
                  <path d="M455.229,78.105c50.367,50.367,78.104,117.333,78.104,188.563c0,71.229-27.739,138.194-78.104,188.561   c-50.368,50.366-117.333,78.104-188.562,78.104c-71.229,0-138.195-27.738-188.562-78.104C27.738,404.862,0,337.896,0,266.668   c0-71.229,27.736-138.196,78.104-188.563S195.438,0,266.667,0C337.896,0,404.861,27.738,455.229,78.105z M431.658,431.659   c32.843-32.843,54.681-73.754,63.686-118.262c-7.019,10.331-13.732,14.165-17.888-8.961c-4.281-37.703-38.911-13.618-60.688-27.011   c-22.919,15.447-74.43-30.032-65.676,21.263c13.507,23.137,72.921-30.964,43.307,17.99   c-18.893,34.176-69.085,109.86-62.555,149.093c0.823,57.158-58.404,11.919-78.81-7.041   c-13.727-37.979-4.678-104.362-40.572-122.962c-38.959-1.691-72.398-5.232-87.497-48.786c-9.086-31.161,9.669-77.549,43.062-84.71   c48.88-30.711,66.341,35.965,112.183,37.205c14.233-14.893,53.029-19.628,56.246-36.328c-30.078-5.308,38.16-25.291-2.879-36.657   c-22.642,2.663-37.229,23.476-25.193,41.124c-43.874,10.23-45.279-63.492-87.454-40.238c-1.072,36.765-68.865,11.919-23.456,4.464   c15.602-6.816-25.448-26.57-3.271-22.98c10.894-0.592,47.569-13.444,37.644-22.084c20.421-12.677,37.583,30.359,57.572-0.98   c14.431-24.097-6.052-28.546-24.141-16.332c-10.198-11.418,18.006-36.081,42.882-46.738c8.29-3.552,16.208-5.487,22.263-4.939   c12.531,14.475,35.703,16.982,36.916-1.741c-31.031-14.861-65.247-22.712-100.672-22.712c-50.845,0-99.203,16.158-139.223,46.036   c10.755,4.927,16.86,11.062,6.499,18.904c-8.05,23.987-40.713,56.186-69.387,51.627c-14.889,25.674-24.694,53.961-28.885,83.608   c24.016,7.946,29.554,23.672,24.394,28.932c-12.237,10.671-19.759,25.797-23.633,42.355c7.817,47.832,30.298,91.914,65.245,126.862   C145.746,475.729,204.34,500,266.667,500C328.992,500,387.587,475.729,431.658,431.659z" 
                    fill="#FFFFFF"/>
                </g>
              </svg>
            </div>
            Kort
          </a>
        </li>
        <li>
          <a data-toggle="sidemenu" aria-controls="sidemenu" @click="syncData">
            <div class="icon">
              <i class="material-icons">sync</i>
              <p class="notification" v-if="notification > 0">!</p>
            </div>
            Synkronisér
          </a>
        </li>
        <li>
          <a href="./files/MålertjekVejledning.pdf" target="_blank">
            <div class="icon">
              <i class="material-icons">help</i>
            </div>
            Hjælp
          </a>
        </li>
        <!-- <li>
          <a data-toggle="sidemenu" aria-controls="sidemenu" @click="gotoSettings">
            <div class="icon">
              <i class="material-icons">settings</i>
            </div>
            Indstillinger
          </a>
        </li> -->
        <li>
          <a data-open="aboutModal" data-toggle="sidemenu" aria-controls="sidemenu" @click="gotoAbout">
            <div class="icon">
              <i class="material-icons">info</i>
            </div>
            Om MålerTjek
          </a>
        </li>
        <!-- <li>
          <a @click="showHelpModal" data-toggle="sidemenu" aria-controls="sidemenu">
            <div class="icon">
              <i class="material-icons">help</i>
            </div>
            Hjælp
          </a>
        </li> -->
        <!-- <li>
          <a data-toggle="sidemenu" aria-controls="sidemenu" @click="logout">
            <div class="icon" style="left: 17px;">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 447.674 447.674" style="enable-background:new 0 0 447.674 447.674;" xml:space="preserve">
                <g>
                  <g>
                    <path d="M182.725,379.151c-0.572-1.522-0.769-2.816-0.575-3.863c0.193-1.04-0.472-1.902-1.997-2.566    c-1.525-0.664-2.286-1.191-2.286-1.567c0-0.38-1.093-0.667-3.284-0.855c-2.19-0.191-3.283-0.288-3.283-0.288h-3.71h-3.14H82.224    c-12.562,0-23.317-4.469-32.264-13.421c-8.945-8.946-13.417-19.698-13.417-32.258V123.335c0-12.562,4.471-23.313,13.417-32.259    c8.947-8.947,19.702-13.422,32.264-13.422h91.361c2.475,0,4.421-0.614,5.852-1.854c1.425-1.237,2.375-3.094,2.853-5.568    c0.476-2.474,0.763-4.708,0.859-6.707c0.094-1.997,0.048-4.521-0.144-7.566c-0.189-3.044-0.284-4.947-0.284-5.712    c0-2.474-0.905-4.611-2.712-6.423c-1.809-1.804-3.949-2.709-6.423-2.709H82.224c-22.648,0-42.016,8.042-58.101,24.125    C8.042,81.323,0,100.688,0,123.338v200.994c0,22.648,8.042,42.018,24.123,58.095c16.085,16.091,35.453,24.133,58.101,24.133    h91.365c2.475,0,4.422-0.622,5.852-1.854c1.425-1.239,2.375-3.094,2.853-5.571c0.476-2.471,0.763-4.716,0.859-6.707    c0.094-1.999,0.048-4.518-0.144-7.563C182.818,381.817,182.725,379.915,182.725,379.151z" fill="#FFFFFF"/>
                    <path d="M442.249,210.989L286.935,55.67c-3.614-3.612-7.898-5.424-12.847-5.424c-4.949,0-9.233,1.812-12.851,5.424    c-3.617,3.617-5.424,7.904-5.424,12.85v82.226H127.907c-4.952,0-9.233,1.812-12.85,5.424c-3.617,3.617-5.424,7.901-5.424,12.85    v109.636c0,4.948,1.807,9.232,5.424,12.847c3.621,3.61,7.901,5.427,12.85,5.427h127.907v82.225c0,4.945,1.807,9.233,5.424,12.847    c3.617,3.617,7.901,5.428,12.851,5.428c4.948,0,9.232-1.811,12.847-5.428L442.249,236.69c3.617-3.62,5.425-7.898,5.425-12.848    C447.674,218.894,445.866,214.606,442.249,210.989z" fill="#FFFFFF"/>
                  </g>
                </g>
              </svg>
            </div>
            Log ud
          </a>
        </li> -->
      </ul>
    </div>

    <help-modal @close="showModal = false" v-if="showModal"></help-modal>

    <div class="reveal" id="aboutModal" data-reveal>
      <div class="reveal-header special-text">
        <img class="logo" src="./assets/image/logo.png" alt="logo">
        <p class="text-center">V. {{version}}, udgivet {{date}}</p>
      </div>
      <div class="reveal-body">
        <h5>MålerTjek&trade; - programmet, der rationaliserer kontrol og udskiftning af forbrugsmålere.</h5>
        <p>NIRAS har udviklet et system, der rationaliserer arbejdsopgaver vedrørende kontrol og udskiftning af forbrugsmålere i forsyningssektoren. Programmet hedder MålerTjek, og med det fjerner du tidsrøvere og gør samtidig livet lettere for både forsyningernes montører og deres administration samt for borgerne. </p>
      </div>
      <img class="niras-logo" src="./assets/image/niraslogo.svg" alt="Niras logo">
      <div class="reveal-footer">
        <p>Har du brug for support til MålerTjek, kan du ringe på support-telefonen <b>2857 5859</b> eller sende en e-mail til <a href="mailto:infosupport@niras.dk?Subject=MålerTjek" target="_top">infosupport@niras.dk</a>.</p>
        <img class="firm-logo" :src="image">
      </div>
      <button class="close-button" data-close aria-label="Close modal" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <main role="main">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import DAL, { mongoObjectId } from './js/Sync/dal';
import clearQueue from './js/Sync/clearQueue';
import zango from 'zangodb';

import helpModal from './components/helpmodal.vue';

import novafoslogo from './assets/image/novafos.jpg';
import lyngbylogo from './assets/image/lyngbyTaarbæk-logo.png';
import taarnbylogo from './assets/image/tårnbyForsyning-logo.png';
import vandlogo from './assets/image/vandOgAffald-logo.png';

var state = {
  date: ''
}

export default {
  name: "app",
  components: {
    Datepicker,
    'help-modal': helpModal
  },
  data() {
    return {
      version: '1.15',
      date: '28. september 2021',
      syncOverlay: false,
      overlay: false,
      state: state,
      errorMessage: '',
      activeStep: 0,
      totalSteps: 8,
      reloadProjekter: false,
      image: '',
      showModal: false
    }
  },
  computed: {
    notification: {
      get() {
        return this.$store.getters.notification;
      },
      set(value) {
        this.$store.dispatch('updateNotification', value)
      }
    }
  },
  methods: {
    showHelpModal() {
      this.overlay = false;
      this.showModal = true;
    },
    showMenu() {
      this.overlay = true;
    },
    closeMenu() {
      this.overlay = false;
    },
    gotoMap() {
      this.overlay = false;
      this.$router.push({
        name: 'kort'
      });
    },
    gotoProjects() {
      this.overlay = false;
      this.$router.push({
        name: 'projekter'
      });
    },
    gotoAbout() {
      this.overlay = false;
    },
    gotoSettings() {
      this.overlay = false;
    },
    syncData() {
      var _this = this;
      var tempdata = [];
      var tempimages = [];
      var bookingId = [];
      var idArr = [];
      var promiseArray = [];
      var user = JSON.parse(this.$cookie.get('user'));
      const promises = [Promise.resolve(), Promise.resolve()]

      this.overlay = false;
      this.errorMessage = '';
      this.syncOverlay = true;

      if (navigator.onLine) {
        clearQueue(promises)
        .then(function () {
          _this.activeStep = 1;
          return new Promise(function (resolve, reject) {
            DAL.iterate("MTTempData", function (value, key, iterationNumber) {
                tempdata.push(value);
            }).then(function () {
              console.log(tempdata)
              resolve(tempdata)
            })
          })
        })
        .then(function () {
          _this.activeStep = 2;
          var tempdataPromises = [];
          for (let i = 0; i < tempdata.length; i++) {
            tempdataPromises.push(function () {
              console.log("tempdata test", tempdata[i]);
              try {
                return new Promise((resolve, reject) => {
                  _this.$http.post(window['url'] +'v' + window['version'] + '/booking/gem', tempdata[i], {params: {'montoernavn': user.navn}})
                  .then(response => resolve(response))
                  .catch(function(err) {
                    reject(new Error("Der skete en fejl!")).then(function(err) {
                      // not called
                    }, function(err) {
                      console.log("error", err);
                      _this.errorMessage = "Der skete en fejl. Prøv igen";
                    })
                  })
                })
                .then(response => {
                  if (response.body > 0) {
                    var id = parseInt(response.body);

                    //var id = {old: tempdata[i].id, new: response.body};
                    idArr.push(id);
                    console.log("idArr", idArr);
                    return response.body;
                  } else {
                    return false;
                  }
                })
              } catch(err) {
                console.log("err step 2 catch")
                _this.errorMessage = "Der gik noget galt. Prøv igen";
              }
            })
            console.log("tempdataPromises", tempdataPromises);
          }
          return clearQueue(tempdataPromises);
          //Aktiverdokumentation
        })
        .then(function () {
          _this.activeStep = 3;
          DAL.clearStore('MTTempData').then(function(result) {
          });
        })
        .then(function () {
          _this.activeStep = 4;
          return new Promise(function (resolve, reject) {
            DAL.iterate("MTTempImages", function (value, key, iterationNumber) {
                tempimages.push(value);
            }).then(function () {
              console.log(tempimages)
              resolve(tempimages)
            })
          })
        })
        .then(function () {
          var tempimagePromises = [];
          for (let i = 0; i < tempimages.length; i++) {
            tempimagePromises.push(function () {
              // Check if some of the images were added to a new project
              // if (idArr) {
              //   idArr.forEach(function(item){
              //     console.log(item);
              //     if(item.old == tempimages[i].projectId){
              //       tempimages[i].projectId = item.new;
              //     }
              //   });
              //   console.log("tempimages projectID after", tempimages[i].projectId);
              // }

              var imageToUpload = {};
              imageToUpload.bookingId = tempimages[i].projectId;
              imageToUpload.base64Data = tempimages[i].base64;
              imageToUpload.filnavn = tempimages[i].fileName;
              console.log("imageToUpload", imageToUpload);
              try {
                return new Promise((resolve, reject) => {
                  _this.$http.post(window['url'] +'v' + window['version'] + '/booking/gembillede', imageToUpload)
                  .then(response => resolve(response))
                  .catch(function(err) {
                    reject(new Error("Der skete en fejl!")).then(function(err) {
                      // not called
                    }, function(err) {
                      console.log("error", err);
                      _this.errorMessage = "Der skete en fejl. Prøv igen";
                    })
                  })
                })
                .then(response => {
                  if (response.body > 0) {
                    return response.body;
                  } else {
                    _this.errorMessage = "Der gik noget galt. Prøv igen";
                    return false;
                  }
                })
              } catch(err) {
                console.log("err step 4 catch", err);
                _this.error = err;
                _this.errorMessage = "Der gik noget galt. Prøv igen" + err;
              }
            })
          }
          return clearQueue(tempimagePromises);
        })
        .then(function () {
          _this.activeStep = 5;
          if (idArr.length > 0) {
            console.log('idArr', idArr)
            try {
              return new Promise((resolve, reject) => {
                _this.$http.post('https://mobileservice.maalertjek.niras.dk/api/v1/booking/aktiverdokumentation', JSON.stringify(idArr))
                .then(response => resolve(response))
                .catch(function(err) {
                    reject(new Error("Der skete en fejl!")).then(function(err) {
                      // not called
                    }, function(err) {
                      console.log("error", err);
                      _this.errorMessage = "Der skete en fejl. Prøv igen";
                    })
                  })
              })
              .then(response => {
                console.log('response aktiverdokumentation', response)
                if (response.body > 0) {
                  return response.body;
                } else {
                  console.log("error", response.body)
                  return false;
                }
              })
            } catch(err) {
              console.log("err step 5 catch", err);
              _this.errorMessage = "Der gik noget galt. Prøv igen" + err;
            }
          }
        })
        .then(function () {
          console.log("image sync done");
          DAL.clearStore('MTTempImages').then(function(result) {
            });
        })
        .then(function () {
          _this.activeStep = 6;
          DAL.clearStore('MTBookingTypes').then(function(result) { });
          DAL.clearStore('MTNoteTypes').then(function(result) { });
          DAL.clearStore('MTPlacementTypes').then(function(result) { });
          DAL.clearStore('MTSettings').then(function(result) { });
          DAL.clearStore('MTTasks').then(function(result) { });
          DAL.clearStore('MTTimeTypes').then(function(result) { });
          DAL.clearStore('MTUsers').then(function(result) { });
        }).then(function () {
          console.log("insert all data");
          clearQueue(promises)
            .then(function () {
              _this.activeStep = 7;
              try {
                return new Promise((resolve, reject) => {
                    _this.$http.get(window['url'] +'v' + window['version'] +'/lister/allelister')
                    .then(response => resolve(response))
                    .catch(function(err) {
                      reject(new Error("Der skete en fejl!")).then(function(err) {
                        // not called
                      }, function(err) {
                        console.log("error", err);
                        _this.errorMessage = "Der skete en fejl. Prøv igen";
                      })
                    })
                })
                .then(response => {
                    console.log("response from step 7", response)
                    return response.body;
                }, response => {
                    console.log("Der opstod en fejl")
                    return false;
                })
              } catch(err) {
                console.log("err step 7 catch", err);
                _this.errorMessage = "Der gik noget galt. Prøv igen";
              }
            })
            .then(function (data) {
                if (data == undefined || data == false) {
                  _this.errorMessage = "Der gik noget galt. Prøv igen";
                  console.log("Der opstod en fejl")
                } else {
                    console.log("inserting into IndexedDB", data.bookinger);
                    var promiseArray = [];
                    console.log("data", data)

                    data.bookinger.forEach(function (booking) {
                        promiseArray.push(function () {
                            return DAL.setItem("MTTasks", booking.id, booking).then(function () {
                              //
                            });
                        })
                    });
                    DAL.setItem("MTBookingTypes", "bookingtypes", data.bookingTyper);
                    DAL.setItem("MTTimeTypes", "timetypes", data.nyTidTyper);
                    DAL.setItem("MTNoteTypes", "notetypes", data.bemaerkningTyper);
                    DAL.setItem("MTPlacementTypes", "placementtypes", data.placeringTyper);
                    DAL.setItem("MTUsers", "users", data.montoerer);

                    return clearQueue(promiseArray);
                }
            })
              .then(function () {
                _this.activeStep = 8;
                console.log("insert settings");
                clearQueue(promises)
                try {
                  return new Promise((resolve, reject) => {
                      _this.$http.get('https://mobileservice.maalertjek.niras.dk/api/indstillinger')
                      .then(response => resolve(response))
                      .catch(function(err) {
                        reject(new Error("Der skete en fejl!")).then(function(err) {
                          // not called
                        }, function(err) {
                          console.log("error", err);
                          _this.errorMessage = "Der skete en fejl. Prøv igen";
                        })
                      })
                  })
                  .then(response => {
                      return response.body;
                  }, response => {
                      return false;
                  })
                } catch(err) {
                  console.log("err step 8 catch", err);
                  _this.errorMessage = "Der gik noget galt. Prøv igen" + err;
                }
              })
              .then(function (data) {
                  if (data == undefined || data == false) {
                      _this.errorMessage = "Der skete en fejl";
                      console.log("der opstod en fejl")
                  } else {
                      window['url'] = data.serviceUrl;
                      window['version'] = data.serviceVersion;
                      return DAL.setItem("MTSettings", "settings", data);
                  }
              }).then(function() {
                _this.syncOverlay = false;
                _this.activeStep = 0;
                _this.errorMessage = '';
                _this.$store.dispatch('updateNotification', 0);
                localStorage.clear();

                _this.$router.push({
                  name: 'default'
                })

                // hent nyt data på projektsiden, så listen opdatere
              })
        })
      } else {
        _this.errorMessage = "Du har ikke noget internet";
        setTimeout(function(){ 
          _this.syncOverlay = false;
          _this.activeStep = 0;
          _this.errorMessage = '';
        }, 5000);
      }
    },
    logout() {
      this.overlay = false;
      this.$router.push({
        name: 'init',
        params: {key: 'Key'}
      });
    }
  },
  mounted() {
    var _this = this;
    $(document).foundation();

    window['apikey']  = this.$cookie.get('apikey');
    window['user']    = JSON.parse(this.$cookie.get('user'));
    window['url']     = this.$cookie.get('url');
    window['version'] = this.$cookie.get('version');

    if (!this.$cookie.get('downloaded')) {
      if (this.$route.name == 'init') {
        window['apikey'] = this.$route.params.key;
        console.log("apikey", window['apikey'])

        this.$router.push({
          name: 'init',
          key: window['apikey']
        })
      } else {
        this.$router.push({
          name: 'default'
        })
      }
    } else {
      DAL.getItem('MTSettings', 'settings').then(function(result) {
        if (result.firmanavn == "Novafos") {
          this.image = novafoslogo;
        }
        if (result.firmanavn == "Lyngby-Taarnbæk Forsyning") {
          this.image = lyngbylogo;
        }
        if (result.firmanavn == "Taarnby Forsyning") {
          this.image = taarnbylogo;
        }
        if (result.firmanavn == "Vand & Affald") {
          this.image = vandlogo;
        }
      });

      DAL.getItem('MTSettings', 'settings').then(function(result) {
        _this.image = result.logoUrl;
      });

      _this.$store.dispatch('updateNotification', (localStorage.getItem('notification') == null ? 0 : localStorage.getItem('notification')));
    }
  }
};
</script>

<style lang="scss">
  @import "./scss/main";
</style>



// WEBPACK FOOTER //
// App.vue?7f6576f6